import { Signal } from '@preact/signals';
import type { UserData } from 'service/user/model';

type SignalData = null | {
	title: string;
	loginSourceComponent: string;
	userData: null | UserData;
	afterAssignUserCallback: () => void;
	closeCallback?: () => void;
};

export class AssignEmailSignal extends Signal<SignalData> {
	constructor(initialValue: SignalData) {
		super(initialValue);
	}

	open(signalData: SignalData) {
		this.value = signalData;
	}

	done() {
		this.value?.afterAssignUserCallback();
		this.value = null;
	}

	close() {
		if (this.value?.closeCallback) {
			this.value?.closeCallback();
		}
		this.value = null;
	}
}

export const assignEmailSignal = new AssignEmailSignal(null);
